import { useContext } from 'react'
import { FormDataContext } from 'providers/FormData'

type SignUpType = 'email' | 'google'

type SignUpData = {
  type: SignUpType
  gToken: string
  data: Record<string, string>
}

type UpdateSignUpData = React.Dispatch<React.SetStateAction<SignUpData>>

type FormData = {
  signUpData: SignUpData
  updateSignUpData: UpdateSignUpData
}

type CurrentData = { type: SignUpType } & Record<string, string>

/**
 * This hook is a control structure for all operations related to different types of Registration (Ex. With Google, Email)
 *
 * @return [Default data for initialization, Current State of the data, Dispatch function to update the data]
 */

const useSignUpData = (): [SignUpData, CurrentData?, UpdateSignUpData?] => {
  const defaultData: SignUpData = {
    type: 'email',
    gToken: 'NA',
    data: {
      first_name: '',
      last_name: '',
      email: '',
    },
  }

  const formData: FormData = useContext(FormDataContext)

  if (formData) {
    const {
      signUpData: {
        type,
        gToken,
        data: { first_name, last_name, email },
      },
      updateSignUpData: updateData,
    } = formData

    const currentData: CurrentData = {
      type,
      gToken,
      first_name,
      last_name,
      email,
    }
    return [defaultData, currentData, updateData]
  } else {
    return [defaultData]
  }
}

export default useSignUpData
